import { isSSR as B, isBrowser as z } from "@fond-of/env";
const t = (e, r) => {
  B() || window.dispatchEvent(
    new CustomEvent(e, {
      detail: r
    })
  );
}, n = (e, r) => {
  const y = (q) => r(q.detail, q);
  return z() && window.addEventListener(e, y), y;
}, o = (e, r) => {
  B() || window == null || window.removeEventListener(e, r);
}, E = "register_failed", Y = (e) => {
  t(E, e);
}, x = (e) => n(E, e), Z = (e) => o(E, e), c = "register", j = (e) => {
  t(c, e);
}, J = (e) => n(c, e), X = (e) => o(c, e), i = "auth", $ = (e) => t(i, e), ee = (e) => n(i, e), te = (e) => o(i, e), v = "login_failed", ne = (e) => {
  t(v, e);
}, oe = (e) => n(v, e), re = (e) => o(v, e), _ = "login", se = (e) => {
  t(_, e);
}, Ee = (e) => n(_, e), ce = (e) => o(_, e), a = "reset_password", ie = (e) => t(a, e), ve = (e) => n(a, e), _e = (e) => o(a, e), d = "reset_password_failed", ae = (e) => t(d, e), de = (e) => n(d, e), ge = (e) => o(d, e), g = "restore_password", Re = (e) => t(g, e), Te = (e) => n(g, e), Se = (e) => o(g, e), R = "restore_password_failed", me = (e) => t(R, e), ue = (e) => n(R, e), Ae = (e) => o(R, e), T = "logout", le = (e) => t(T, e), Ne = (e) => n(T, e), Ie = (e) => o(T, e), S = "cart", s = (e) => t(S, e), Ce = (e) => n(S, e), Ve = (e) => o(S, e), m = "increase_cart_item", we = (e) => {
  s({ cart: e.cart }), t(m, e);
}, Le = (e) => n(m, e), he = (e) => o(m, e), u = "decrease_cart_item", Pe = (e) => {
  s({ cart: e.cart }), t(u, e);
}, De = (e) => n(u, e), Oe = (e) => o(u, e), A = "view_cart", pe = (e) => {
  t(A, e);
}, Fe = (e) => n(A, e), fe = (e) => o(A, e), l = "show_add_to_cart_side_panel", Ue = (e) => t(l, e), We = (e) => n(l, e), Me = (e) => o(l, e), N = "add_cart_code", Ge = (e) => {
  s({ cart: e.cart }), t(N, e);
}, be = (e) => n(N, e), ke = (e) => o(N, e), I = "remove_cart_code", He = (e) => {
  s({ cart: e.cart }), t(I, e);
}, Qe = (e) => n(I, e), ye = (e) => o(I, e), C = "begin_checkout", V = "add_payment_info", w = "add_shipping_info", L = "purchase", qe = (e) => {
  t(C, e);
}, Be = (e) => n(C, e), ze = (e) => {
  o(C, e);
}, Ke = (e) => {
  t(V, e);
}, Ye = (e) => n(V, e), xe = (e) => {
  o(V, e);
}, Ze = (e) => {
  t(L, e);
}, je = (e) => n(L, e), Je = (e) => {
  o(L, e);
}, Xe = (e) => {
  t(w, e);
}, $e = (e) => n(w, e), et = (e) => {
  o(w, e);
}, h = "virtual_page_view", tt = (e) => t(h, e), nt = (e) => n(h, e), ot = (e) => o(h, e), P = "apply_list_filters", rt = (e) => t(P, e), st = (e) => n(P, e), Et = (e) => o(P, e), D = "login_link_requested", ct = (e) => t(D, e), it = (e) => n(D, e), vt = (e) => o(D, e), O = "user_registered", _t = (e) => t(O, e), at = (e) => n(O, e), dt = (e) => o(O, e), p = "start_return", gt = (e) => t(p, e), Rt = (e) => n(p, e), Tt = (e) => o(p, e), F = "error_return", St = (e) => t(F, e), mt = (e) => n(F, e), ut = (e) => o(F, e), f = "order_return", At = (e) => t(f, e), lt = (e) => n(f, e), Nt = (e) => o(f, e), U = "show_qr_code_return", It = (e) => t(U, e), Ct = (e) => n(U, e), Vt = (e) => o(U, e), W = "save_qr_code_return", wt = (e) => t(W, e), Lt = (e) => n(W, e), ht = (e) => o(W, e), M = "save_return_label", Pt = (e) => t(M, e), Dt = (e) => n(M, e), Ot = (e) => o(M, e), G = "view_product_detail", pt = (e) => t(G, e), Ft = (e) => n(G, e), ft = (e) => o(G, e), b = "no_search_result", Ut = (e) => t(b, e), Wt = (e) => n(b, e), Mt = (e) => o(b, e), k = "shoe_size_finder", Gt = (e) => t(k, e), bt = (e) => n(k, e), kt = (e) => o(k, e), H = "add_wishlist_item", Ht = (e) => {
  t(H, e);
}, Qt = (e) => n(H, e), yt = (e) => o(H, e), Q = "remove_wishlist_item", qt = (e) => {
  t(Q, e);
}, Bt = (e) => n(Q, e), zt = (e) => o(Q, e);
export {
  be as onAddCartCodeEvent,
  Ye as onAddPaymentInfoEvent,
  $e as onAddShippingInfoEvent,
  Qt as onAddWishlistItemEvent,
  st as onApplyListFiltersEvent,
  ee as onAuthEvent,
  Be as onBeginCheckoutEvent,
  Ce as onCartEvent,
  De as onDecreaseCartItemEvent,
  mt as onErrorReturnEvent,
  Le as onIncreaseCartItemEvent,
  Ee as onLoginEvent,
  oe as onLoginFailedEvent,
  it as onLoginLinkRequested,
  Ne as onLogoutEvent,
  Wt as onNoSearchResultEvent,
  lt as onOrderReturnEvent,
  je as onPurchaseEvent,
  J as onRegisterEvent,
  x as onRegisterFailedEvent,
  Qe as onRemoveCartCodeEvent,
  Bt as onRemoveWishlistItemEvent,
  ve as onResetPasswordEvent,
  de as onResetPasswordFailedEvent,
  Te as onRestorePasswordEvent,
  ue as onRestorePasswordFailedEvent,
  Lt as onSaveQrCodeReturnEvent,
  Dt as onSaveReturnLabelEvent,
  bt as onShoeSizeFinderEvent,
  We as onShowAddToCartSidePanelEvent,
  Ct as onShowQrCodeReturnEvent,
  Rt as onStartReturnEvent,
  at as onUserRegistered,
  Fe as onViewCartEvent,
  Ft as onViewProductDetailEvent,
  nt as onVirtualPageViewEvent,
  ke as removeAddCartCodeEvent,
  xe as removeAddPaymentInfoEvent,
  et as removeAddShippingInfoEvent,
  yt as removeAddWishlistItemEvent,
  Et as removeApplyListFiltersEvent,
  te as removeAuthEvent,
  ze as removeBeginCheckoutEvent,
  Ve as removeCartEvent,
  Oe as removeDecreaseCartItemEvent,
  ut as removeErrorReturnEvent,
  he as removeIncreaseCartItemEvent,
  ce as removeLoginEvent,
  re as removeLoginFailedEvent,
  vt as removeLoginLinkRequested,
  Ie as removeLogoutEvent,
  Mt as removeNoSearchResultEvent,
  Nt as removeOrderReturnEvent,
  Je as removePurchaseEvent,
  X as removeRegisterEvent,
  Z as removeRegisterFailedEvent,
  ye as removeRemoveCartCodeEvent,
  zt as removeRemoveWishlistItemEvent,
  _e as removeResetPasswordEvent,
  ge as removeResetPasswordFailedEvent,
  Se as removeRestorePasswordEvent,
  Ae as removeRestorePasswordFailedEvent,
  ht as removeSaveQrCodeReturnEvent,
  Ot as removeSaveReturnLabelEvent,
  kt as removeShoeSizeFinderEvent,
  Me as removeShowAddToCartSidePanelEvent,
  Vt as removeShowQrCodeReturnEvent,
  Tt as removeStartReturnEvent,
  dt as removeUserRegistered,
  fe as removeViewCartEvent,
  ft as removeViewProductDetailEvent,
  ot as removeVirtualPageViewEvent,
  n as subscribeEvent,
  Ge as triggerAddCartCodeEvent,
  Ke as triggerAddPaymentInfoEvent,
  Xe as triggerAddShippingInfoEvent,
  Ht as triggerAddWishlistItemEvent,
  rt as triggerApplyListFiltersEvent,
  $ as triggerAuthEvent,
  qe as triggerBeginCheckoutEvent,
  s as triggerCartEvent,
  Pe as triggerDecreaseCartItemEvent,
  St as triggerErrorReturnEvent,
  t as triggerEvent,
  we as triggerIncreaseCartItemEvent,
  se as triggerLoginEvent,
  ne as triggerLoginFailedEvent,
  ct as triggerLoginLinkRequested,
  le as triggerLogoutEvent,
  Ut as triggerNoSearchResultEvent,
  At as triggerOrderReturnEvent,
  Ze as triggerPurchaseEvent,
  j as triggerRegisterEvent,
  Y as triggerRegisterFailedEvent,
  He as triggerRemoveCartCodeEvent,
  qt as triggerRemoveWishlistItemEvent,
  ie as triggerResetPasswordEvent,
  ae as triggerResetPasswordFailedEvent,
  Re as triggerRestorePasswordEvent,
  me as triggerRestorePasswordFailedEvent,
  wt as triggerSaveQrCodeReturnEvent,
  Pt as triggerSaveReturnLabelEvent,
  Gt as triggerShoeSizeFinderEvent,
  Ue as triggerShowAddToCartSidePanelEvent,
  It as triggerShowQrCodeReturnEvent,
  gt as triggerStartReturnEvent,
  _t as triggerUserRegistered,
  pe as triggerViewCartEvent,
  pt as triggerViewProductDetailEvent,
  tt as triggerVirtualPageViewEvent,
  o as unsubscribeEvent
};
//# sourceMappingURL=event.js.map
